const newgamePromotionActivity = {
  th: {
    ng: {
      promotionActivity: {
        claimCoupon: "กดรับคูปองภายในเวลาที่กำหนด",
        clickBaccaratFormulaButton: "กดปุ่ม “สูตรบาคาร่า”",
        clickPromotionButton: "กดปุ่ม “โปรโมชั่น”",
        closeActivityGuide: "ปิดคู่มือกิจกรรมเครดิตฟรี",
        closePromotion: "ปิดหน้าต่างเลือกโบนัส",
        closePromotionDetails: "ปิดรายละเอียดโปรโมชั่น",
        completeVideos: "ดูวิดีโอให้ครบทุกขั้นตอน",
        confirmPromotion: "ต้องการรับโปรโมชั่น {{name}} ใช่หรือไม่?",
        enterActivityCode: "กรอกโค้ดที่ได้รับจากการเล่นกิจกรรม",
        findBrandWebsite:
          "ค้นหาลิงก์เว็บไซต์ <siteName>{{site}}</siteName>",
        findFreeCreditActivity: "เลื่อนหาเมนูกิจกรรมเครดิตฟรี",
        guideIntro: "ขั้นตอนการเล่นกิจกรรมเครดิตฟรี",
        guideTitle: "ขั้นตอนการเล่นกิจกรรมเครดิตฟรีของ {{brand}}",
        nextStepVideo: "กดปุ่ม NEXT STEP เพื่อดูวิดีโอถัดไป",
        openBrandSearch: "คลิก <searchLink>{{brand}}</searchLink>",
        playMatchingGame: "เล่นเกมจับคู่ภาพ",
        promotionImage: "รูปโปรโมชั่น {{name}}",
        returnToPlay:
          "กลับไปยังหน้าเล่น หรือคลิก <playLink>mem.jaosua999.com</playLink>",
        searchBrandOnGoogle:
          "คลิกลิงก์ <searchLink>Google</searchLink> แล้วค้นหาคำว่า {{brand}}",
        stepImage: "ภาพประกอบขั้นตอนที่ {{step}}",
        stepLabel: "ขั้นตอนที่ {{step}}",
        watchPlayVideo: "กดปุ่ม PLAY แล้วดูวิดีโอจนจบ",
      },
    },
  },
  en: {
    ng: {
      promotionActivity: {
        claimCoupon: "Claim the coupon within the specified time",
        clickBaccaratFormulaButton: "Click the Baccarat Formula button",
        clickPromotionButton: "Click the Promotions button",
        closeActivityGuide: "Close the free-credit activity guide",
        closePromotion: "Close bonus selection",
        closePromotionDetails: "Close promotion details",
        completeVideos: "Watch every video in all steps",
        confirmPromotion: "Do you want to accept the {{name}} promotion?",
        enterActivityCode: "Enter the code received from the activity",
        findBrandWebsite:
          "Find the <siteName>{{site}}</siteName> website link",
        findFreeCreditActivity: "Scroll to find the Free Credit Activity",
        guideIntro: "How to participate in the Free Credit Activity",
        guideTitle: "{{brand}} Free Credit Activity Guide",
        nextStepVideo: "Click NEXT STEP to watch the next video",
        openBrandSearch: "Click <searchLink>{{brand}}</searchLink>",
        playMatchingGame: "Play the picture-matching game",
        promotionImage: "{{name}} promotion",
        returnToPlay:
          "Return to the play page or click <playLink>mem.jaosua999.com</playLink>",
        searchBrandOnGoogle:
          "Open <searchLink>Google</searchLink> and search for {{brand}}",
        stepImage: "Step {{step}} illustration",
        stepLabel: "Step {{step}}",
        watchPlayVideo: "Click PLAY and watch the video to the end",
      },
    },
  },
  cn: {
    ng: {
      promotionActivity: {
        claimCoupon: "在规定时间内领取优惠券",
        clickBaccaratFormulaButton: "点击“百家乐公式”按钮",
        clickPromotionButton: "点击“优惠活动”按钮",
        closeActivityGuide: "关闭免费额度活动指南",
        closePromotion: "关闭奖励选择",
        closePromotionDetails: "关闭优惠活动详情",
        completeVideos: "完成所有步骤并看完全部视频",
        confirmPromotion: "您要领取“{{name}}”优惠吗？",
        enterActivityCode: "输入参加活动后获得的代码",
        findBrandWebsite: "找到 <siteName>{{site}}</siteName> 网站链接",
        findFreeCreditActivity: "向下滚动并找到免费额度活动",
        guideIntro: "免费额度活动参加步骤",
        guideTitle: "{{brand}} 免费额度活动指南",
        nextStepVideo: "点击 NEXT STEP 观看下一个视频",
        openBrandSearch: "点击 <searchLink>{{brand}}</searchLink>",
        playMatchingGame: "玩图片配对游戏",
        promotionImage: "{{name}} 优惠图片",
        returnToPlay:
          "返回游戏页面，或点击 <playLink>mem.jaosua999.com</playLink>",
        searchBrandOnGoogle:
          "打开 <searchLink>Google</searchLink> 并搜索 {{brand}}",
        stepImage: "第 {{step}} 步示意图",
        stepLabel: "第 {{step}} 步",
        watchPlayVideo: "点击 PLAY 并观看完整视频",
      },
    },
  },
  mm: {
    ng: {
      promotionActivity: {
        claimCoupon: "သတ်မှတ်ထားသော အချိန်အတွင်း ကူပွန်ကို ရယူပါ",
        clickBaccaratFormulaButton: "Baccarat Formula ခလုတ်ကို နှိပ်ပါ",
        clickPromotionButton: "ပရိုမိုးရှင်း ခလုတ်ကို နှိပ်ပါ",
        closeActivityGuide: "အခမဲ့ခရက်ဒစ် အစီအစဉ်လမ်းညွှန်ကို ပိတ်ရန်",
        closePromotion: "ဘောနပ်စ်ရွေးချယ်မှုကို ပိတ်ရန်",
        closePromotionDetails: "ပရိုမိုးရှင်းအသေးစိတ်ကို ပိတ်ရန်",
        completeVideos: "အဆင့်အားလုံးရှိ ဗီဒီယိုများကို အဆုံးထိကြည့်ပါ",
        confirmPromotion: "{{name}} ပရိုမိုးရှင်းကို ရယူလိုပါသလား?",
        enterActivityCode: "အစီအစဉ်မှ ရရှိသော ကုဒ်ကို ထည့်ပါ",
        findBrandWebsite:
          "<siteName>{{site}}</siteName> ဝက်ဘ်ဆိုက်လင့်ခ်ကို ရှာပါ",
        findFreeCreditActivity: "အခမဲ့ခရက်ဒစ် အစီအစဉ်ကို ရှာရန် အောက်သို့ဆွဲပါ",
        guideIntro: "အခမဲ့ခရက်ဒစ် အစီအစဉ်တွင် ပါဝင်နည်း",
        guideTitle: "{{brand}} အခမဲ့ခရက်ဒစ် အစီအစဉ်လမ်းညွှန်",
        nextStepVideo: "နောက်ဗီဒီယိုကိုကြည့်ရန် NEXT STEP ကို နှိပ်ပါ",
        openBrandSearch: "<searchLink>{{brand}}</searchLink> ကို နှိပ်ပါ",
        playMatchingGame: "ပုံတူတွဲဖက်ဂိမ်းကို ကစားပါ",
        promotionImage: "{{name}} ပရိုမိုးရှင်းပုံ",
        returnToPlay:
          "ကစားရန်စာမျက်နှာသို့ ပြန်သွားပါ သို့မဟုတ် <playLink>mem.jaosua999.com</playLink> ကို နှိပ်ပါ",
        searchBrandOnGoogle:
          "<searchLink>Google</searchLink> ကိုဖွင့်ပြီး {{brand}} ကို ရှာပါ",
        stepImage: "အဆင့် {{step}} ပုံညွှန်း",
        stepLabel: "အဆင့် {{step}}",
        watchPlayVideo: "PLAY ကို နှိပ်ပြီး ဗီဒီယိုအဆုံးထိ ကြည့်ပါ",
      },
    },
  },
};

export default newgamePromotionActivity;
